import { RootState } from "./root.reducer";
import { DevicesState } from "./devices/devices.reducer";
import { SettingsState } from "./settings/settings.reducer";
import { NotificationState } from "../components/notification";
import { SBCategory } from "./categories/categories.types";
import { LayoutState } from "./layout";
import { BannersState } from "./banners/banners.types";
import { ReportsState } from "./reports/reports.types";

export const getDevices = (state: RootState): DevicesState => state.devices;
export const getAccount = (state: RootState) => state.account;
export const getAccountSettings = (state: RootState) => state.accountSettings;
export const getSettings = (state: RootState): SettingsState => state.settings;
export const getReports = (state: RootState): ReportsState => state.reports;
export const getConfig = (state: RootState) => state.config;
export const getDomainLookup = (state: RootState) => state.domainLookup;
export const getWebFilters = (state: RootState) => state.webFilters;
export const getProtections = (state: RootState) => state.protections;
export const getCategories = (state: RootState): SBCategory[] =>
  state.categories;
export const getSubscriberInfo = (state: RootState) => state.subscriberInfo;
export const getResources = (state: RootState) => state.resources;
export const getNotifications = (state: RootState): NotificationState =>
  state.notifications;
export const getThreats = (state: RootState) => state.threats;
export const getSessionStatus = (state: RootState) => state.isSessionExpired;
export const getProfiles = (state: RootState) => state.profiles;
export const getSSProfiles = (state: RootState) => state.ssProfiles;
export const getSchedules = (state: RootState) => state.schedules;
export const getTranslation = (state: RootState) => state.translation;
export const getUrlFilters = (state: RootState) => state.urlFilters;
export const getLayout = (state: RootState): LayoutState => state.layout;
export const getBanners = (state: RootState): BannersState => state.banners;
export const getDeepLink = (state: RootState) => state.deepLink;
